<template>
<Toast />
<div></div>
</template>

<script>
export default {
  name: "ConnexionJboss",
  created() {
    this.MSG_ERREUR = "Votre accès a été refusé. Revérifiez vos informations de connexion."
  },
  mounted() {
    if ((this.$commun.findGetParameter('jeton') !== null && this.$commun.findGetParameter('jeton') !== "") 
        || (this.$commun.findGetParameter('name') !== null && this.$commun.findGetParameter('name') !== "")) {
    
      this.jeton = this.$commun.findGetParameter('jeton')
      this.identifiant = this.$commun.findGetParameter('name')
      
      this.$store
        .dispatch('cardex/connexionAction', {
          usager: this.identifiant,
          mdp: this.mdp
        })
        .then(() => {
          this.$commun.removeUrlQueryParams();
          this.$router.push({ name: "choix-profil" })
          this.loading = false
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
          this.toast('error', this.MSG_ERREUR)
        });

    } else {
      this.toast('error', this.MSG_ERREUR)
    }
  },
  data() {
    return {
      loading: false,
      identifiant: null,
      mdp: null,
      jeton: '',
    }
  },
  methods: {
    toast(level, msg) {
      this.$toast.add({ severity: level, detail: msg, summary: 'Connexion', life: 6000 });
    }
  }
};
</script>
